module.exports = __webpack_public_path__ + "static/media/02n.8fda18da.svg";